import axios from "axios";
import { useState } from "react";
import { get_users_reports_traffic } from "../../api/api";
import queryString from 'query-string'


const FilterReportUserChoose = ({ queries, setData, active, mode, chartActive }) => {

    const [isLoading, setIsLoading] = useState(false)

    const handleOnClick = async () => {
        try {
            setData({})
            setIsLoading(true)
            const res = await axios.get(get_users_reports_traffic(queryString.stringify(queries)))
            setData({ type: 1, data: res.data, mode: mode })

        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <>
            <button
                disabled={isLoading}
                className={`moreFiltersButton ${active?.filterUserId ? 'active' : ''} ${mode ? 'chartModeBtn' : ''}`}
                type="button"
                onClick={handleOnClick}>{isLoading ? '...' : 'کاربر'}
                {!isLoading && active?.filterUserId ? ': ' + active.filterUserId?.name : ''}
            </button>
        </>
    );
}

export default FilterReportUserChoose;